// Last-stroke power (W) straight from PM5 CE060036. 0 until the first stroke.
// Attaches whenever Erg mode is on, and re-attaches on every PM5 (re)connect.
import { useEffect, useState } from 'react';
import { attachStrokePower, activePM5 } from '@/lib/pm5StrokePower';
import { getPM5Connection } from '@/lib/pm5Connection';

export default function usePm5StrokeWatts({ enabled, sessionActive }) {
  const [strokeWatts, setStrokeWatts] = useState(0);
  const [connTick, setConnTick] = useState(0);

  useEffect(() => { setStrokeWatts(0); }, [sessionActive]);

  useEffect(() => {
    const bump = () => setConnTick((n) => n + 1);
    window.addEventListener('pm5-connected', bump);
    return () => window.removeEventListener('pm5-connected', bump);
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    let detach = () => {};
    let cancelled = false;
    attachStrokePower(activePM5(getPM5Connection())).then((fn) => { if (cancelled) fn(); else detach = fn; });
    const onWatts = (e) => { if (Number.isFinite(e.detail?.watts)) setStrokeWatts(e.detail.watts); };
    window.addEventListener('crewz-stroke-watts', onWatts);
    return () => {
      cancelled = true;
      detach();
      window.removeEventListener('crewz-stroke-watts', onWatts);
    };
  }, [enabled, connTick]);

  return strokeWatts;
}
